module.exports = __webpack_public_path__ + "img/introductionToPython.97f2efd9.jpg";